<template>
  <div>
    <b-alert v-if="dateWarning && !dateExpired" show variant="warning">Η ημερομηνία λήξης αιτήσεων συμμετοχής πλησιάζει</b-alert>
    <b-alert v-if="dateExpired" show variant="danger">Η ημερομηνία λήξης αιτήσεων συμμετοχής έχει παρέλθει</b-alert>
  <b-row>
    <b-form-group
        :label="$t('training-announcement.organizerUnit')"
        label-for="input-id"
        label-align="left"
        class="col-md-3"
        label-class="font-weight-bold"
    >
      <p class="text-left">{{ activity.organizerUnit.name}}</p>

    </b-form-group>
    <b-form-group
        :label="$t('training-announcement.method')"
        label-for="input-no"
        label-align="left"
        class="col-md-4"
        label-class="font-weight-bold"
    >
      <p class="text-left">{{ translateTrainingMethod(activity.method) }}</p>

    </b-form-group>


    <b-form-group
        :label="$t('training-announcement.applicationsExpireDate')"
        label-for="input-no"
        label-align="left"
        class="col-md-4"
        label-class="font-weight-bold"
    >
      <p class="text-left">{{ prettifyDate(activity.applicationsExpireDate) }}</p>

    </b-form-group>

    <b-form-group
        :label="$t('training-announcement.leader')"
        label-for="input-no"
        label-align="left"
        class="col-md-4"
        label-class="font-weight-bold"
    >
      <p class="text-left">{{ leaderFullName }}</p>

    </b-form-group>

    <b-form-group
        :label="$t('training-announcement.paymentType')"
        label-for="input-no"
        class="col-md-4"
        label-align="left"
        label-class="font-weight-bold"
    >

      <b-badge
          v-for="tag in this.activity.paymentTypes"
          :key="tag"
          class="ml-auto"
          :title="tag"
      >
        {{ translatePaymentType(tag) }}
      </b-badge>

    </b-form-group>

    <b-form-group
        :label="$t('training-announcement.cost')"
        label-for="input-no"
        label-align="left"
        v-if="cost>0"
        class="col-md-3"
        label-class="font-weight-bold"
    >
      <p class="text-left">{{ cost }}€</p>
    </b-form-group>

  </b-row>
  <b-form-group
      :label="$t('training-announcement.periods')"
      label-for="input-no"
      label-align="left"
      v-if="cost>=0"
      class="col-md-12"
      label-class="font-weight-bold"
  >

    <b-table striped hover :items="this.activity.periods" :fields="fields"
             responsive
    >
      <template v-slot:cell(startDate)="row">
        {{ prettifyDateTime(row.item.startDate) }}
      </template>

      <template v-slot:cell(endDate)="row">
        {{ prettifyDateTime(row.item.endDate) }}
      </template>

    </b-table>

  </b-form-group>
  <b-row>
    <b-form-group
        :label="$t('training-announcement.eligibility')"
        label-for="input-amount"
        label-align="left"
        class="col-md-12"
        label-class="font-weight-bold"
        v-if="this.activity.eligibilitySection"
    >
      <div  class="text-justify" v-html="this.activity.eligibilitySection"></div>
    </b-form-group>

    <b-form-group
        :label="$t('training-announcement.applicationInfo')"
        label-for="input-amount"
        label-align="left"
        class="col-md-12"
        label-class="font-weight-bold"
        v-if="this.activity.applicationInfoSection"
    >
      <div class="text-justify" v-html="this.activity.applicationInfoSection"></div>
    </b-form-group>

    <b-form-group
        label-align="left"
        label="Πληροφορίες"
        class="col-md-12"
        label-class="font-weight-bold"
        v-if="this.activity.commentsSection"
    >
      <div class="text-justify" v-html="this.activity.commentsSection"></div>
    </b-form-group>

  </b-row>
    <b-row v-if="!dateExpired">

      <div class="col text-center">
        <b-button class="btn btn-primary" variant="success" @click="goToApplication()">
          {{ $t("participation.apply") }}
        </b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
import {prettifyDate, prettifyDateTimeLong} from "@/services/utils";

export default {
  computed: {
    dateWarning() {
      if (!this.activity) {
        return false;
      }
      const yesterday = new Date(this.activity.applicationsExpireDate);
      yesterday.setDate(yesterday.getDate() - 3);

      return yesterday < new Date();
    },
    dateExpired() {
      if (!this.activity) {
        return false;
      }
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() -1);
      return yesterday >= new Date(this.activity.applicationsExpireDate);
    },
    cost(){
      return this.activity.module.billMethod.rules.filter(r => r.rule == 'TRAINING_FEE')[0].billingValue / 100.0
    },
    leaderFullName() {
      // return this.activity.leader;
      return `${this.activity.leader.member.surName} ${this.activity.leader.member.firstName}`
    },
    getTitle(){
      if (!this.activity) {
        return "-";
      }
      return `${this.activity.location!==null? this.activity.location +': ': ''}${this.activity?.module?.title}`
    }
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      fields: [
        {key: "location", label: "Τοποθεσία", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        {key: "startDate", label: "Έναρξη", sortable: false},
        {key: "endDate", label: "Λήξη", sortable: false}
      ],
    }
  },
  methods: {
    prettifyDate(date){
      return prettifyDate(date);
    },
    prettifyDateTime(date){
      return prettifyDateTimeLong(date);
    },
    translateTrainingMethod(method){
      return this.$t(`trainingMethodEnums.${method}`)
    },
    translatePaymentType(type){
      return this.$t(`paymentTypeEnums.${type}`)
    },
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
      if(errors?.length>0) {
        window.scrollTo(0,0);
      }
    },
    showSuccess(successMessage) {
      this.successMessage = successMessage;
      this.popSuccessAlert = true;
      window.scrollTo(0,0);
      this.getActivityById();
    },
    goToApplication() {
      window.location.href = `/app/training/web/trainings/apply?activityId=${this.activity.id}`;
    },
  },
  name: 'Announcement',
  props: {
    activity: {}
  }
}
</script>